export const FAT_PER_CHOCOLATE_GRAMS = 50
const MAX_CHOCOLATE_ICONS = 100

export type ChocolateBars =
   | { type: 'none' }
   | { type: 'message' }
   | { type: 'icons'; count: number; overflow: number }

/**
 * Converts burned fat into whole "chocolate bars" for the reward display:
 * nothing until fat is burned, a teaser message under one bar, then icons
 * capped at `MAX_CHOCOLATE_ICONS` with the remainder as an overflow count.
 *
 * @param totalGrams - Fat burned in grams.
 * @returns The reward state.
 */
export function getChocolateBars(totalGrams: number): ChocolateBars {
   if (!Number.isFinite(totalGrams) || totalGrams <= 0) {
      return { type: 'none' }
   }
   const barCount = Math.floor(totalGrams / FAT_PER_CHOCOLATE_GRAMS)
   if (barCount <= 0) {
      return { type: 'message' }
   }
   return {
      type: 'icons',
      count: Math.min(MAX_CHOCOLATE_ICONS, barCount),
      overflow: Math.max(0, barCount - MAX_CHOCOLATE_ICONS),
   }
}
